/**
 * Local Angular glue over @svayam/iam-client's framework-agnostic CORE.
 * NOT '@svayam/iam-client/angular' — that plain-tsc ESM entry dual-instances
 * Angular under the dev optimizer (NG0912/NG0203). Wire locally from the core
 * until the SDK ships its Angular entry via ng-packagr (tracked).
 */
import { InjectionToken, inject, type Provider } from '@angular/core';
import type { HttpInterceptorFn } from '@angular/common/http';
import { Router, type CanActivateFn } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { IamClient, type IamClientConfig } from '@svayam/iam-client';

export const IAM_CLIENT = new InjectionToken<IamClient>('svayam.iam-client');

export function provideIamClient(config: IamClientConfig): Provider[] {
  return [{ provide: IAM_CLIENT, useFactory: () => new IamClient(config) }];
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const client = inject(IAM_CLIENT);
  const router = inject(Router);
  const toIam = req.url.startsWith(client.config.iamBaseUrl);
  const token = client.token;
  const authed = toIam && token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;
  return next(authed).pipe(
    catchError((err: { status?: number }) => {
      if (toIam && err?.status === 401) { client.logout(); void router.navigate(['/']); }
      return throwError(() => err);
    })
  );
};

export const authGuard: CanActivateFn = () => {
  const client = inject(IAM_CLIENT);
  const router = inject(Router);
  if (client.isLoggedIn) return true;
  void router.navigate(['/']);
  return false;
};
